import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';

const AkFullTable = ({ report, total, onSortChange }) => {
    const rows = report.map((row, index) => (<Row row={row} key={index} />));

    return (
        <Table bordered responsive>
            <Head onSortChange={onSortChange}/>
            <tbody>
                <TotalRow data={total}/>
                {rows}
            </tbody>
        </Table>
    )
};

export default AkFullTable;


// WEBPACK FOOTER //
// ./src/scenes/AkFull/components/Table/index.js